<template>
  <div class="checkbox" :class="setClassModifiers('checkbox--') + (error ? '  checkbox--error' : '')">
    <input type="checkbox" class="checkbox__input" v-model="model" :id="val" :value="val" :disabled="disabled" @change="$emit('change')">
    <label :for="val" class="checkbox__label" :class="labelClass">
      <!-- @slot default for render label -->
      <slot></slot>
      {{ !$slots.default ? label : null }}
    </label>
    <div class="checkbox__error" v-if="error">{{error}}</div>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'
export default {
  name: 'v-checkbox',
  props: {
    /**
     * @model
     */
    value: {
      type: [Array, Boolean],
      default: () => []
    },
    /**
      * Initial values of radio buttons
      */
    val: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * @values boxed
     */
    type: {
      type: String,
      default: null
    },

    labelClass: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: null
    },

    error: {
      type: String,
      default: null
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        /**
        * Used for v-model
        * @property {String}
        */

        if (Array.isArray(val)) {
          this.$emit('input', val)
          return
        }

        this.$emit('input', JSON.parse(val))
      }
    }
  },
  mounted () {
  },
  mixins: [setClassModifiers]
}
</script>

<style lang="scss">
  .checkbox {
    padding-top: .3rem;
    padding-bottom: .2rem;

    &--boxed {
      .checkbox__label {
        background-color: $color-white;
        padding: 1.1rem 1.5rem;
        border: 1.2px $color-azure solid;
        border-radius: $border-radius;
      }

      &.checkbox--error {
        .checkbox__label {
          border-color: $color-error;
        }
      }

      .checkbox__input:checked + .checkbox__label {
        content: '\e903';
        border-color: $color-primary;
      }
    }

    &__input {
      display: none;
    }

    &__label {
      cursor: pointer;
      font-family: inherit;
      font-size: inherit;
      display: flex;
      align-items: flex-start;

      &::before {
        content: '';
        font-family: 'icomoon',serif;
        width: 1.8rem;
        min-width: 1.8rem;
        height: 1.8rem;
        margin-right: 1rem;
        margin-top: 0;
        border: 1.5px $color-space-light solid;
        border-radius: $border-radius;
        font-size: 1rem;
        padding: .15rem .3rem;
        transition: all .2s;
        color: $color-white;
      }
    }

    &__input:checked + &__label::before {
      content: '\e903';
      background-color: $color-secondary;
      border-color: $color-secondary;
    }

    &__input:disabled + &__label {
      cursor: default;
      background-color: $color-grey-extra-light;
      border-color: $color-space-light!important;
      color: $color-space;

      &::before {
        background-color: $color-grey-lighten;
        border-color: $color-space-light;
      }
    }

    &__error {
      margin-top: .2rem;
      color: $color-error;
    }
  }
</style>
